export const SHARP_ADJUSTMENTS = {
  brightness: 0,
  contrast: 5,
  highlight: 5,
  shadow: -5,
  saturation: 0,
  warmth: 0,
  blur: 0,
  exposure: 10,
  white: 6,
  black: 14,
  structure: 35,
  clarity: 20,
  dehaze: 0,
  vignette: 0,
  grain: 0,
  red: 0,
  orange: 0,
  yellow: 0,
  green: 0,
  aqua: 0,
  blue: 0,
  purple: 0,
  magenta: 0,
  // Adding the new color adjustments
  hsl_hue_red: -8,
  hsl_hue_orange: -2,
  hsl_hue_yellow: 0,
  hsl_hue_green: 0,
  hsl_hue_aqua: 0,
  hsl_hue_blue: 0,
  hsl_hue_purple: 0,
  hsl_hue_magenta: 0,
  hsl_saturation_red: 20,
  hsl_saturation_orange: -10,
  hsl_saturation_yellow: -10,
  hsl_saturation_green: -6,
  hsl_saturation_aqua: 0,
  hsl_saturation_blue: 0,
  hsl_saturation_purple: 0,
  hsl_saturation_magenta: 0,
  hsl_luminance_red: 0,
  hsl_luminance_orange: 0,
  hsl_luminance_yellow: 0,
  hsl_luminance_green: 0,
  hsl_luminance_aqua: 0,
  hsl_luminance_blue: 0,
  hsl_luminance_purple: 0,
  hsl_luminance_magenta: 0,
  hsl_all_hue: 0,
  hsl_all_saturation: 0,
  hsl_all_luminance: 0,
  rgb_red: 0,
  rgb_green: 0,
  rgb_blue: 0,
}

export const DEFAULT_ADJUSTMENTS = {
  brightness: 0,
  contrast: 0,
  highlight: 0,
  shadow: 0,
  saturation: 0,
  warmth: 0,
  blur: 0,
  exposure: 0,
  white: 0,
  black: 0,
  structure: 0,
  clarity: 0,
  dehaze: 0,
  vignette: 0,
  grain: 0,
  red: 0,
  orange: 0,
  yellow: 0,
  green: 0,
  aqua: 0,
  blue: 0,
  purple: 0,
  magenta: 0,
  // Adding the new color adjustments
  hsl_hue_red: 0,
  hsl_hue_orange: 0,
  hsl_hue_yellow: 0,
  hsl_hue_green: 0,
  hsl_hue_aqua: 0,
  hsl_hue_blue: 0,
  hsl_hue_purple: 0,
  hsl_hue_magenta: 0,
  hsl_saturation_red: 0,
  hsl_saturation_orange: 0,
  hsl_saturation_yellow: 0,
  hsl_saturation_green: 0,
  hsl_saturation_aqua: 0,
  hsl_saturation_blue: 0,
  hsl_saturation_purple: 0,
  hsl_saturation_magenta: 0,
  hsl_luminance_red: 0,
  hsl_luminance_orange: 0,
  hsl_luminance_yellow: 0,
  hsl_luminance_green: 0,
  hsl_luminance_aqua: 0,
  hsl_luminance_blue: 0,
  hsl_luminance_purple: 0,
  hsl_luminance_magenta: 0,
  hsl_all_hue: 0,
  hsl_all_saturation: 0,
  hsl_all_luminance: 0,
  rgb_red: 0,
  rgb_green: 0,
  rgb_blue: 0,
};


export const INITIAL_ADJUSTMENTS = {
  brightness: 0,
  contrast: 0,
  highlight: 0,
  shadow: 0,
  saturation: 0,
  warmth: 0,
  blur: 0,
  exposure: 0,
  white: 0,
  black: 0,
  structure: 0,
  clarity: 0,
  dehaze: 0,
  vignette: 0,
  grain: 0,
  red: 0,
  orange: 0,
  yellow: 0,
  green: 0,
  aqua: 0,
  blue: 0,
  purple: 0,
  magenta: 0,
  // Adding the new color adjustments
  hsl_hue_red: 0,
  hsl_hue_orange: 0,
  hsl_hue_yellow: 0,
  hsl_hue_green: 0,
  hsl_hue_aqua: 0,
  hsl_hue_blue: 0,
  hsl_hue_purple: 0,
  hsl_hue_magenta: 0,
  hsl_saturation_red: 0,
  hsl_saturation_orange: 0,
  hsl_saturation_yellow: 0,
  hsl_saturation_green: 0,
  hsl_saturation_aqua: 0,
  hsl_saturation_blue: 0,
  hsl_saturation_purple: 0,
  hsl_saturation_magenta: 0,
  hsl_luminance_red: 0,
  hsl_luminance_orange: 0,
  hsl_luminance_yellow: 0,
  hsl_luminance_green: 0,
  hsl_luminance_aqua: 0,
  hsl_luminance_blue: 0,
  hsl_luminance_purple: 0,
  hsl_luminance_magenta: 0,
  hsl_all_hue: 0,
  hsl_all_saturation: 0,
  hsl_all_luminance: 0,
  rgb_red: 0,
  rgb_green: 0,
  rgb_blue: 0,
};
